import { signal, Service } from '@angular/core';
import { ACL_PERMISSIONS, AclPermission } from './util-acl/models/acl-permission';
import { AclRoles } from './util-acl/models/acl-roles';

@Service()
export class AclService {
  private readonly roles = signal<AclRoles[]>([]);

  /**
   * Metodo per settare i ruoli dell'utente loggato
   */
  public setRoles(roles: AclRoles[]): void {
    this.roles.set(roles);
  }

  /**
   * Usato dalla direttiva nel template.
   */
  public hasRole(roles: AclRoles | AclRoles[]): boolean {
    const roleList = Array.isArray(roles) ? roles : [roles];
    return roleList.some((role) => this.roles().includes(role));
  }

  /**
   * Usato nel TS dei componenti
   */
  public hasPermission(permission: AclPermission | AclPermission[]): boolean {
    const permissionList = Array.isArray(permission) ? permission : [permission];

    return permissionList.some((p) => {
      switch (p) {
        case ACL_PERMISSIONS.ADMIN_ACCESS:
          return this.roles().includes(AclRoles.Admin);
        default:
          return false;
      }
    });
  }
}
